import dayjs from "dayjs";

export const formatValue = (value: any, type: string, customFormat: string | null = null) => {
    if (customFormat) {
        if (customFormat == "Time24") {
            let startHour = dayjs().startOf('day').toDate();
            startHour.setMinutes(value);
            return dayjs(startHour);
        }
    }
    else if (type === "date") {
        if (value)
            return dayjs(value);
        else
            return dayjs();
    }
    else if(type==="number"&&value==null){
        return '';
    }
    return value;
}

export const formatValueAsReadOnly = (value: any, type: string, customFormat: string | null = null,ismultiSelect:boolean=false) => {
    
    if (customFormat) {
        if (customFormat == "Time24") {
            let startHour = dayjs().startOf('day').toDate();
            startHour.setMinutes(value);
            return dayjs(startHour).format('HH:mm');
        }
    }
    else if (type === "checkbox") {
        if (value)
            return <p>&#10004;</p> 
        else
            return <p>&#10006;</p>
    }
    else if(!value){
        return "-";
    }
    else if (type === "date") {
        return dayjs(new Date(value)).format("DD MMMM, YYYY")
    }
    else if(ismultiSelect){
        return value.join(',');
    }
    else
        return value;
}

export const formatValueForApi = (value: any, type: string,isNullable:boolean) => {
    if (type === "date") {
        //const pad = (num: number) => num.toString().padStart(2, '0');
        
        return !isNullable&&value==null?dayjs(new Date()).format("DD MMMM, YYYY")
        :(dayjs(value)).format('YYYY-MM-DDTHH:mm:ss');; //.toLocaleDateString();
    }
    else if (type === "checkbox") {
        return value == null ? false : value;
    }
    return value;

}

